import { render, staticRenderFns } from "./Versiculo.vue?vue&type=template&id=63e582b6&scoped=true"
import script from "./Versiculo.vue?vue&type=script&lang=js"
export * from "./Versiculo.vue?vue&type=script&lang=js"
import style0 from "./Versiculo.vue?vue&type=style&index=0&id=63e582b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e582b6",
  null
  
)

export default component.exports